import React, { useCallback } from "react";
import { VariableSizeList } from "react-window";

const BASE_HEIGHT = 35;
const CHAR_PER_LINE = 30; // Adjust based on your dropdown width and font size

const DropdownOptionMenuList = (props: any) => {
  const { options, children, maxHeight, getValue } = props;
  const childrenArray = React.Children.toArray(children);

  // Estimate height: 1 line for short, 2 lines for long text
  const getItemSize = useCallback(
    (index: number) => {
      const child = childrenArray[index];
      let text = "";
      if (child && (child as any).props && (child as any).props.children) {
        const childContent = (child as any).props.children;
        if (typeof childContent === "string") {
          text = childContent;
        } else if (Array.isArray(childContent)) {
          text = childContent.join(" ");
        }
      }
      const lines = Math.ceil(text.length / CHAR_PER_LINE) || 1;
      return BASE_HEIGHT * lines;
    },
    [childrenArray]
  );

  const selected = getValue()[0];
  const initialOffset = options.indexOf(selected) * BASE_HEIGHT;

  return (
    <VariableSizeList
      height={Math.min(
        maxHeight,
        childrenArray.reduce((sum: number, _: any, idx: number) => sum + getItemSize(idx), 0)
      )}
      itemCount={childrenArray.length}
      itemSize={getItemSize}
      initialScrollOffset={initialOffset}
      width="100%"
    >
      {({ index, style }: { index: number; style: React.CSSProperties }) => (
        <div style={{ ...style, whiteSpace: "normal", lineHeight: "1.2" }}>
          {childrenArray[index]}
        </div>
      )}
    </VariableSizeList>
  );
};

export default DropdownOptionMenuList;